export function getTextWidth(text: string, font: string) {
    const context = document.createElement("canvas").getContext("2d")
    if (context) {
        context.font = font
        const metrics = context.measureText(text)
        return metrics?.width
    }
}
